module.exports = __webpack_public_path__ + "img/48b2720dd4dfea1149376f09b8673df2.png";